import React from "react";
import "../styles/genieTabButton.css";

/**
 * The shared "AI Assistant" tab button, used anywhere the POS surfaces an AI assistant — the
 * Roster screen and Product Management today. Deliberately not styled like the plain
 * `hardwareTabBtn`s beside it: it should read as "something different lives here" at a glance
 * rather than blend in as one more equal tab. A genie's lamp + sparkle, gold-to-crimson gradient
 * (picking up the app's own accent red rather than the generic purple-blue "AI" cliché), and a
 * soft pulsing glow while unopened; the glow settles once it's the active tab so it stops
 * demanding attention after someone is already looking at it.
 *
 * Kept as one component precisely so these entry points cannot drift apart visually — a second
 * hand-rolled gradient button on another screen is how that starts.
 */
const LampSparkleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M4.5 17.2c0-2.35 2.6-3.7 4.9-3.7h4.3c1.9 0 3.4.95 3.4 2.4s-1.6 2.4-3.7 2.4H9.2"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M17.1 15.6c1.5 0 2.8-.75 2.8-1.85s-1.1-1.65-2.05-1.65"
      stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    <circle cx="6.3" cy="18.7" r="1.25" fill="currentColor" />
    <path d="M9.6 4.3l.85 1.9 1.9.85-1.9.85-.85 1.9-.85-1.9-1.9-.85 1.9-.85z" fill="currentColor" />
    <path d="M16 2.4l.5 1.1 1.1.5-1.1.5-.5 1.1-.5-1.1-1.1-.5 1.1-.5z" fill="currentColor" />
  </svg>
);

const GenieTabButton = ({ active, onClick }) => (
  <button
    type="button"
    className={`genieTabBtn ${active ? "active" : ""}`}
    role="tab"
    aria-selected={active}
    onClick={onClick}
  >
    <LampSparkleIcon />
    <span>AI Assistant</span>
  </button>
);

export default GenieTabButton;
